import * as React from 'react';
import Icons from "../../Icons";
import Modal from "react-responsive-modal";
import {GalleryFile} from "../../iMonCompte";
import {ModalGallery} from "./ModalGallery";
import {getBoutiqueColor, getUserId, sessionExpire} from "../../MonCompteAction";
import {useEffect, useState} from "react";
import {UploadBtn} from "./UploadBtn";
import axios from "axios";
import {getHostApi, getRequestConfig} from "../../../../utils";

interface GalleryProps {
  selectedFileName: string;
  onUpdateInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  identifier: string,
  display: string,
  marquage: any,
  canGalerie: boolean,
  idCommande: string,
  emplacementId: string
  surfaceId: string,
  surfaceNom: string,
  color: string;
  pictoId: number;
  idCaddies: number;
  onSelectedFilesUpdated?(selectedFile: GalleryFile): void;
  authorizedFiles: string[];
  isInterne: boolean;
}

export const Gallery = (props: GalleryProps) => {
  const [openGallery, setOpenGallery] = useState<boolean>(false);
  const [lstFiles, setLstFiles] = useState<GalleryFile[]>([]);
  const [lstFilesBatAuto, setLstFilesBatAuto] = useState<GalleryFile[]>([]);
  const [lstFilesSansBatAuto, setLstFilesSansBatAuto] = useState<GalleryFile[]>([]);

  useEffect(() => {
    fetchFiles();
  }, []);

  function fetchFiles() {
    axios.post(`${getHostApi()}/customers/${getUserId()}/galleries/files/orders/${props.idCommande}/surfaces/${props.surfaceId}/emplacements/${props.emplacementId}/pictos/${props.pictoId}`,
      {
        idCaddies: props.idCaddies,
        marquageId: props.marquage.id
      }, getRequestConfig()).then((response) => {
      if (response.data) {
        setLstFiles(response.data);
        trierFilesGalerie(response.data);
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  function trierFilesGalerie(data: GalleryFile[]) {
    if(data) {
      const tmpLstBatAuto = [];
      const tmpLstSansBatAuto = [];
      for (const file of data) {
        if(file.isBatAuto) {
          tmpLstBatAuto.push(file);
        } else {
          tmpLstSansBatAuto.push(file);
        }
      }
      setLstFilesBatAuto(tmpLstBatAuto);
      setLstFilesSansBatAuto(tmpLstSansBatAuto);
    }
  }

  /**
   * Fonciton définissant les actions à faire lors de la fermeture de la modal galerie par le bouton "Annuler"
   */
  function onCancelModal() {
    setOpenGallery(false);
  }

  /**
   * Fonction permettant de transmettre le visuel sélectionné au composant parent (ici RenderFileLine.tsx)
   *
   * @private
   */
  function sendSelectedFiles(selectedFile: GalleryFile) {
    if (props.onSelectedFilesUpdated) {
      props.onSelectedFilesUpdated(selectedFile);
    }
  }


  const GalleryBtn = () => {
    return (
      <button
              className={`border cursor-pointer d-flex btnImportGalerie `}
              style={{background: getBoutiqueColor()}} onClick={() => setOpenGallery(true)}>
        <label className={'label-file white border-0 py-2 px-3 cursor-pointer m-0 importButton label-file-' +
                 props.marquage.nom + '-' + props.surfaceId}
               style={{background: getBoutiqueColor()}}>
          <Icons icon="file_upload" size={25} color="#fff" className="mr-2"/>
          <span className={"d-flex align-items-center"}>Importer&nbsp;<span className="hide-for-small">une image</span></span>
        </label>
      </button>
    );
  };

  const renderModalButtons = () => {
    return (
      <div className="mt-4 d-flex justify-content-center">
        <button title="Annuler" onClick={onCancelModal}
                className="fabBtn border-0 bold  cursor-pointer btnCancelModal  py-2 px-3     bg-black white cursor-pointer  lineheight1 buttonPrimary text-center p-4 pl-5 pr-5  ">
          FERMER
        </button>
      </div>
    );
  };

  const GalleryModal = () => {

    const infosUpload = {
      identifier: props.identifier,
      onUpdateInput: props.onUpdateInput,
      selectedFileName: props.selectedFileName,
      authorizedFiles: props.authorizedFiles,
      marquageNom: props.marquage.nom,
      surfaceId: props.surfaceId,
      idCaddies: props.idCaddies,
      marquageId: props.marquage.id,
      pictoId: props.pictoId,
      emplacementId: props.emplacementId
    }

    return (
      <Modal open={openGallery} onClose={onCancelModal} center
             classNames={{
               overlay: 'bootstrap-container', 
               modal: 'galleryModalContainer customModal',
               closeButton: 'galleryModalCloseButton closeButton'
             }}>
        <div className="modalGalerie p-2 position-relative pa0Mobile">
          <p className={"bold black text-uppercase mb-4 font16"}><Icons icon="collections" size={20} color="#000"/> Ma Galerie</p>
          <div>
            <ModalGallery orderId={props.idCommande} bgColor={props.color} lstFiles={lstFiles} isInterne={props.isInterne}
                          onSelectedFilesUpdated={sendSelectedFiles} lstFilesBatAuto={lstFilesBatAuto} onDownloadFile={onCancelModal}
                          infosUpload={infosUpload} lstFilesSansBatAuto={lstFilesSansBatAuto}/>
          </div>
          <div className={"d-none"} id="btnValidationGallery">
            {renderModalButtons()}
          </div>
        </div>
      </Modal>
    );
  };

  if (props.canGalerie && ((lstFiles?.length > 0 && props.isInterne) || (!props.isInterne && lstFilesBatAuto?.length > 0))) {
    return (
      <div>
        {GalleryBtn()}
        {GalleryModal()}
      </div>
    )
  } else {
    return (
      <UploadBtn identifier={props.identifier} onUpdateInput={props.onUpdateInput} selectedFileName={props.selectedFileName} authorizedFiles={props.authorizedFiles} marquageNom={props.marquage.nom} surfaceId={props.surfaceId}/>
    );
  }
}
